import { connect } from "react-redux";
import { setIsRedirecting } from "rivals/redux/application/actions";
import { getIsRedirecting } from "rivals/redux/application/selectors";
import { loginUser } from "rivals/redux/authentication/actions";
import { isAuthenticated } from "rivals/redux/authentication/selectors";
import { State } from "rivals/redux/reducer";
import { getSubmitting } from "rivals/redux/user/selectors";
import { DispatchProps, StateProps } from "./types";
import LoginForm from ".";

const mapStateToProps = (state: State): StateProps => ({
  authenticated: isAuthenticated(state),
  isRedirecting: getIsRedirecting(state),
  submitting: getSubmitting(state)
});

const mapDispatchToProps: DispatchProps = {
  loginUser,
  setIsRedirecting
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);
